import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Tadasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Tadasana.title1"), context: t("Tadasana.context1") },
      { title: t("Tadasana.title2"), context: t("Tadasana.context2") },
      { title: t("Tadasana.title3"), context: t("Tadasana.context3") },
      { title: t("Tadasana.title4"), context: t("Tadasana.context4") },
      { title: t("Tadasana.title5"), context: t("Tadasana.context5") },
      { title: t("Tadasana.title6"), context: t("Tadasana.context6") },
      { title: t("Tadasana.title7"), context: t("Tadasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Tadasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/tadasana.mp4'}
                title="Description"
                context={t("Tadasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Tadasana
